<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import utils from "@/utils/utils";
import store from '@/store'
export default {
  name: "app",
  components: {},
  created() {
    const storageToken = localStorage.getItem("authorization");
    const cookieToken = utils.getCookie("xsToken");
      if (!storageToken) {
        if (cookieToken) {
          localStorage.setItem("authorization", cookieToken);
        }
      }else{
        // console.log('走这里')
        const roleCode = store.state.user.currentRoleCode;
        if(roleCode!="#ROLE1#ROLE2"&&roleCode!="#ROLE1"){
          localStorage.setItem("authorization", cookieToken);
        }
      }
  },
};
</script>

<style>
@import "//at.alicdn.com/t/font_2481600_gutzsf87g9n.css";
@import "//at.alicdn.com/t/font_2481600_6ltg8sihwao.css"; /*学说*/
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100vh;
}
</style>
